const setPreferencesButton = document.querySelector(".js--cookie-button");

if (setPreferencesButton) {
  setPreferencesButton.addEventListener("click", () => {
    const checkedCookieInput = document.querySelector(
      ".cookie-bar__options input[type=radio]:checked"
    );

    pushCookieTypesToDataLayer(checkedCookieInput.dataset.gtmCookieTypes);
  });
}

const acceptAllButtons = document.querySelectorAll(".js--cookie-button-all");

[].forEach.call(acceptAllButtons, (acceptAllButton) => {
  acceptAllButton.addEventListener("click", () => {
    pushCookieTypesToDataLayer(acceptAllButton.dataset.gtmCookieTypes);
  });
});

function pushCookieTypesToDataLayer(types) {
  window.dataLayer.push({
    event: "enableCookie",
    cookieTypes: types,
  });

  types.split(",").forEach((type) => {
    window.dataLayer.push({
      event: "enableCookie",
      cookieType: type,
    });
  });
}
